import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onBeforeUnmount, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopScroll',
  props: {
    tableEl: null
  },
  setup(__props: any) {

const props = __props as { tableEl: HTMLElement }



const baseTable = ref(props.tableEl);
const vsPanel = ref();

const topScrollBar = ref<HTMLElement | null>(null);
const isShow = ref(false);
const speedMultiplier = 2;
let viewWidth = 0;
let barWidth = 0;
let maxBarScroll = 0;

let resizeObserver: ResizeObserver | null = null;
let mutationObserver: MutationObserver | null = null;

const recalculate = () => {
    isShow.value = baseTable.value.offsetWidth !== vsPanel.value.clientWidth;

    const contentWidth = baseTable.value.offsetWidth;
    viewWidth = vsPanel.value.offsetWidth;
    barWidth = Math.round(viewWidth / 4);
    topScrollBar.value.style.width = `${barWidth}px`;

    maxBarScroll = contentWidth - barWidth;

    const scrollRatio = vsPanel.value.scrollLeft / (contentWidth - viewWidth);
    const newLeft = Math.min(maxBarScroll, scrollRatio * maxBarScroll);
    topScrollBar.value.style.transform = `translateX(${newLeft}px)`;
};

const onMouseDown = (event: MouseEvent) => {
    const startX = event.clientX;
    const startLeft = parseFloat(
        topScrollBar.value.style.transform.replace('translateX(', '').replace('px)', '') || '0',
    );

    const onMouseMove = (moveEvent: MouseEvent) => {
        const deltaX = (moveEvent.clientX - startX) * speedMultiplier;
        let newLeft = startLeft + deltaX;

        newLeft = Math.max(0, Math.min(newLeft, maxBarScroll));

        const scrollRatio = newLeft / maxBarScroll;
        vsPanel.value.scrollLeft = scrollRatio * (baseTable.value.offsetWidth - viewWidth);

        topScrollBar.value!.style.transform = `translateX(${newLeft}px)`;
    };

    const onMouseUp = () => {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
};

const onPanelScroll = () => {
    const contentWidth = baseTable.value.offsetWidth;
    const scrollRatio = vsPanel.value.scrollLeft / (contentWidth - viewWidth);
    const newLeft = Math.min(maxBarScroll, scrollRatio * maxBarScroll);
    topScrollBar.value.style.transform = `translateX(${newLeft}px)`;
};

onMounted(() => {
    vsPanel.value = baseTable.value.closest('.__panel');

    if (!baseTable.value || !vsPanel.value || !topScrollBar.value) return;

    resizeObserver = new ResizeObserver(() => recalculate());
    resizeObserver.observe(baseTable.value);

    mutationObserver = new MutationObserver(() => recalculate());
    mutationObserver.observe(baseTable.value, { childList: true, subtree: true, attributes: true });

    vsPanel.value.addEventListener('scroll', onPanelScroll);
    topScrollBar.value.addEventListener('mousedown', onMouseDown);

    recalculate();
});

onBeforeUnmount(() => {
    if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
    }

    if (mutationObserver) {
        mutationObserver.disconnect();
        mutationObserver = null;
    }

    if (vsPanel.value) {
        vsPanel.value.removeEventListener('scroll', onPanelScroll);
    }

    if (topScrollBar.value) {
        topScrollBar.value.removeEventListener('mousedown', onMouseDown);
    }
});

return { __sfc: true,props, baseTable, vsPanel, topScrollBar, isShow, speedMultiplier, viewWidth, barWidth, maxBarScroll, resizeObserver, mutationObserver, recalculate, onMouseDown, onPanelScroll }
}

})